import React, { useEffect } from 'react';
import styled from 'styled-components';
import { DropdownMenuBase } from '../DropdownMenu/DropdownMenuBase';
import { a11y } from '../DropdownMenu/strings';
import { useMediaSize } from '../tools/utils';
export const StyledTabButton = styled.button `
  ${({ theme: { fonts, font, colors, space }, $active }) => `
    font-size: ${font.body.md.size};
    font-family: ${fonts.regular};
    line-height: ${font.body.md.lineHeight};
    background: none;
    border: none;
    cursor: pointer;
    padding: unset;
    padding-bottom: ${space.xxs}; 
    margin-bottom: -1px;
    box-sizing: border-box;

    ${$active
    ? `
            color: ${colors['gray-900']};
            border-bottom: 2px solid ${colors['gray-900']};
          `
    : `
          color: ${colors.bluesuedeshoes};
          font-weight: bold;
          border-bottom: 2px solid transparent;
        `}
  `}
`;
export const HeaderContainer = styled.div `
  ${({ theme: { fonts, colors, space }, $includeDivider }) => `
    display: flex;
    gap: 24px;
    margin-bottom: ${space.md};
    font-family: ${fonts.regular};
    ${$includeDivider ? `border-bottom: 1px solid ${colors['slate-200']};` : ``}
  `}
`;
const StyledDropdownBase = styled(DropdownMenuBase) `
  margin-bottom: ${({ theme: { space } }) => space.lg};
`;
export const TabsHeaderTabList = ({ tabs, activeTab, selectedTab, onActiveTabChange, onSelectedTabChange, }) => {
    const tabsRef = React.useRef(Array(tabs.length + 1));
    useEffect(() => {
        var _a;
        if (activeTab != null && tabsRef.current[activeTab] != null) {
            (_a = tabsRef.current[activeTab]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [activeTab]);
    const onKeyDown = (e, sourceIndex) => {
        if (e.key === 'Tab' && e.shiftKey) {
            // This prevent a weird issue where shift + tab would skip a tab
            if (sourceIndex !== 0) {
                e.preventDefault();
            }
            if (sourceIndex === 0) {
                onActiveTabChange(null);
            }
            else {
                onActiveTabChange((sourceIndex !== null && sourceIndex !== void 0 ? sourceIndex : 0) - 1);
            }
        }
        else if (e.key === 'Tab') {
            // This prevent a weird issue where pressing tab would skip a tab
            if (sourceIndex !== tabs.length - 1) {
                e.preventDefault();
            }
            if (sourceIndex === tabs.length - 1) {
                onActiveTabChange(null);
            }
            else {
                onActiveTabChange((sourceIndex !== null && sourceIndex !== void 0 ? sourceIndex : 0) + 1);
            }
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            if (sourceIndex === 0 && (e.key === 'ArrowLeft' || e.key === 'ArrowUp')) {
                onSelectedTabChange(tabs.length - 1, false);
            }
            else {
                onSelectedTabChange((sourceIndex !== null && sourceIndex !== void 0 ? sourceIndex : 0) - 1, false);
            }
        }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            if (sourceIndex === tabs.length - 1 &&
                (e.key === 'ArrowRight' || e.key === 'ArrowDown')) {
                onSelectedTabChange(0, false);
            }
            else {
                onSelectedTabChange((sourceIndex !== null && sourceIndex !== void 0 ? sourceIndex : 0) + 1, false);
            }
        }
    };
    return (React.createElement(React.Fragment, null, tabs.map((tab, index) => {
        var _a;
        return (React.createElement(StyledTabButton, { "data-allytmln": tab.allytmln, key: tab.label, onClick: () => {
                onSelectedTabChange(index, true);
            }, "$active": selectedTab === index, ref: (r) => {
                tabsRef.current[index] = r;
            }, onKeyDown: (e) => onKeyDown(e, index), "aria-selected": selectedTab === index, role: "tab", "aria-label": (_a = tab.ariaLabel) !== null && _a !== void 0 ? _a : tab.label, type: "button" }, tab.label));
    })));
};
export const TabsHeader = ({ tabs, selectedTab, onSelectedTabChange, disableContainer = false, activeTab = null, onActiveTabChange, disableDropdownSmDown, dropdownPlacement, dropdownOpen, handleDropdownOpenChange, accessibleDropdownTitle, }) => {
    const isSmDown = useMediaSize('SmDown');
    const mobileMode = !disableDropdownSmDown && isSmDown;
    return (React.createElement(HeaderContainer, Object.assign({ "$includeDivider": disableContainer && !mobileMode }, (!mobileMode ? { role: 'tablist' } : {})), !mobileMode ? (React.createElement(TabsHeaderTabList, { tabs: tabs, selectedTab: selectedTab, onSelectedTabChange: onSelectedTabChange, activeTab: activeTab, onActiveTabChange: onActiveTabChange })) : (React.createElement(StyledDropdownBase, { dropdownItems: tabs.map(tab => {
            var _a;
            return ({
                variant: 'button',
                text: tab.label,
                ariaLabel: (_a = tab.ariaLabel) !== null && _a !== void 0 ? _a : tab.label,
                allytmln: tab.allytmln,
            });
        }), placement: dropdownPlacement, open: dropdownOpen, onOpenChange: handleDropdownOpenChange, activeIndex: activeTab, title: accessibleDropdownTitle, onActiveIndexChange: onActiveTabChange, selectedIndex: selectedTab, onSelectedIndexChange: (i) => onSelectedTabChange(i, true), selectionAsTitle: true, disableReturnFocus: true, ariaLabelTrigger: a11y.ariaLabelTrigger }))));
};
//# sourceMappingURL=TabsHeader.js.map